import { reatomAsync, withDataAtom } from "@reatom/async";
import { withAbort } from "@reatom/framework";
import { API } from "src/api.ts";
import { withDebounce } from "src/common/pipes";

import { dashboardDateRangeAtom } from "../atom";

export const getOrdersByDatesRequest = reatomAsync(async (ctx) => {
  const filter = ctx.get(dashboardDateRangeAtom);
  return API.orderApi
    .orderControllerGetOrdersByDates(filter || {}, {
      signal: ctx.controller.signal,
    })
    .then((response) => response.data);
}, "getOrdersByDatesRequest").pipe(withDataAtom(null), withAbort());

export const getOrdersByDatesWithDebouncing = getOrdersByDatesRequest.pipe(
  withDebounce(200),
);
